/**
 * Format an ISO date string as DD/MM/YYYY HH:MM
 * @param {string} dateStr
 * @returns {string}
 */
export function formatDate(dateStr) {
  const d = new Date(dateStr);
  return (
    d.toLocaleDateString(window.navigator.language, {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }) +
    " " +
    d.toLocaleTimeString(window.navigator.language, {
      hour: "2-digit",
      minute: "2-digit",
    })
  );
}

/**
 * Human-readable relative time for past events.
 * @param {string} dateStr
 * @returns {string}
 */
export function daysAgo(dateStr) {
  const d = new Date(dateStr);
  const diff = Math.round((Date.now() - d.getTime()) / (1000 * 60 * 60 * 24));
  if (diff === 0) return "today";
  if (diff === 1) return "yesterday";
  return `${diff} days ago`;
}

/**
 * Number of days until an upcoming event.
 * @param {string} dateStr
 * @returns {number}
 */
export function daysToGo(dateStr) {
  const d = new Date(dateStr);
  return Math.round((d.getTime() - Date.now()) / (1000 * 60 * 60 * 24));
}

/**
 * Compute views ÷ impressions as a rounded percentage.
 * Returns null when impressions === 0 (undefined ratio).
 *
 * @param {number} impressions
 * @param {number} views
 * @returns {number|null}
 */
export function getRatio(impressions, views) {
  const imp = Number(impressions);
  const vws = Number(views);
  if (!imp || !isFinite(imp)) {
    return null;
  }
  return Math.round((vws / imp) * 100);
}
/**
 * Map a ratio percentage to a display level.
 *
 * - high  (green)  : > 100% — more direct/QR views than widget impressions
 * - med   (amber)  : 50–100% — both channels contributing
 * - low   (grey)   : < 50%  — mostly widget discovery, low direct share
 *
 * @param {number} ratio
 * @returns {{ level: "high"|"med"|"low" }}
 */
export function getRatioMeta(ratio) {
  if (ratio > 100) return { level: "high" };
  if (ratio >= 50) return { level: "med" };
  return { level: "low" };
}

/**
 * Maps a ratio level to the Untitled Badge `color` prop.
 */
export const RATIO_BADGE_COLOR = {
  high: "success",
  med: "warning",
  low: "gray",
};
